import { getOpColor } from './colorUtils.js';
const colors_light_all = {
  //品牌紫赛博紫mauve
  mauve_1: '#EEEBFF',
  mauve_2: '#DDD7FF',
  mauve_3: '#C3B8F6',
  mauve_4: '#A293EE',
  mauve_5: '#8E5FFF', //26-3-4修订
  mauve_6: '#7039E5', //26-3-4修订
  mauve_7: '#5D2CC7', //26-3-4修订
  mauve_8: '#4920A0', //26-3-4修订
  mauve_9: '#290870',
  mauve_10: '#170146',

  //品牌蓝赛博蓝blue
  blue_1: '#E0F2FF',
  blue_2: '#CCE9FF',
  blue_3: '#99D3FF',
  blue_4: '#75C3FF',
  blue_5: '#32A4FB',
  blue_6: '#0190FF',
  blue_7: '#0A78CC',
  blue_8: '#084F85',
  blue_9: '#032A47',
  blue_10: '#011629',

  //睿易绿sdGreen
  kygreen_1: '#E8F9F2',
  kygreen_2: '#D4F4E7',
  kygreen_3: '#95E5C4',
  kygreen_4: '#66DAAA', //26-3-4修订
  kygreen_5: '#31CD8C',
  kygreen_6: '#04C273',
  kygreen_7: '#07A562',
  kygreen_8: '#047C4A',
  kygreen_9: '#025935',
  kygreen_10: '#013620',

  //睿易蓝sdBlue
  kyblue_1: '#EAF2FF',
  kyblue_2: '#DEEAFF',
  kyblue_3: '#B0CDFF',
  kyblue_4: '#75A8FF',
  kyblue_5: '#4589FF',
  kyblue_6: '#1B6DFA',
  kyblue_7: '#0C53CD',
  kyblue_8: '#0A41A0',
  kyblue_9: '#052D73',
  kyblue_10: '#011B46',
  kyblue_11: '#EAF2FF', //只能暗黑用，大家不可直接引用哈//26-3-4修订

  //中性色neutral colors
  gray_1: '#FFFFFF',
  gray_2: '#F5F7FA',
  gray_3: '#EDF0F5',
  gray_4: '#E9EBF0',
  gray_5: '#DFE2E8',
  gray_6: '#CCD0D9',
  gray_7: '#B5BBC7',
  gray_8: '#9EA5B2',
  gray_9: '#797E8A', //26-3-4修订
  gray_10: '#565B66',
  gray_11: '#30343D', //26-3-4修订
  gray_12: '#1A1E26', //26-3-4修订
  gray_13: '#000000',

  //日暮橙Orange
  orange_1: '#FFF5EB',
  orange_2: '#FFE9D4',
  orange_3: '#FFD1A3',
  orange_4: '#FFBF80',
  orange_5: '#FFA64D',
  orange_6: '#FF9226',
  orange_7: '#D97D23',
  orange_8: '#A35B14',
  orange_9: '#75400B',
  orange_10: '#472604',

  //紫罗兰purple
  purple_1: '#F9EEFF',
  purple_2: '#F5E0FF',
  purple_3: '#E4BCF7',
  purple_4: '#D99CF7',
  purple_5: '#BF64EE',
  purple_6: '#B848F0',
  purple_7: '#8F34BD ',
  purple_8: '#6A1F8F',
  purple_9: '#491266',
  purple_10: '#2E0942',

  //柠檬绿lime
  lime_1: '#F1F9E5',
  lime_2: '#E6F5D0',
  lime_3: '#CBEBA0',
  lime_4: '#B7E07E',
  lime_5: '#9AD448',
  lime_6: '#87C72E',
  lime_7: '#76B224',
  lime_8: '#578618',
  lime_9: '#3E600F',
  lime_10: '#253B07',

  //金盏花yellow
  yellow_1: '#FEF7E3',
  yellow_2: '#FEF0CB',
  yellow_3: '#FDDF8E',
  yellow_4: '#FAD56E',
  yellow_5: '#F7C53B',
  yellow_6: '#F5B505',
  yellow_7: '#D19900',
  yellow_8: '#A57900',
  yellow_9: '#6E5100',
  yellow_10: '#463300',

  //薄暮红Red
  red_1: '#FFF1F0',
  red_2: '#FFE7E5',
  red_3: '#FFBEBA',
  red_4: '#FF9E99',
  red_5: '#FF706E',
  red_6: '#FC5151',
  red_7: '#D93D3D',
  red_8: '#A12D2D',
  red_9: '#701D1D',
  red_10: '#4D1212',

  //以下色系尽量少用
  //法式洋红 Magenta
  magenta_1: '#FFEDF4',
  magenta_2: '#FFE0ED',
  magenta_3: '#FFB8D8',
  magenta_4: '#FF99CA',
  magenta_5: '#FA66B8', //26-3-4修订
  magenta_6: '#F04AA5', //26-3-4修订
  magenta_7: '#CC2D8A', //26-3-4修订
  magenta_8: '#A32473', //26-3-4修订
  magenta_9: '#7A1155',
  magenta_10: '#52083B',

  //锐捷红 jiered//26-3-4修改
  brandred_1: '#FDEEF1',
  brandred_2: '#FFE3EA',
  brandred_3: '#FFB8C9',
  brandred_4: '#FC83A1',
  brandred_5: '#EC406B',
  brandred_6: '#E60039',
  brandred_7: '#C70031',
  brandred_8: '#990026',
  brandred_9: '#70001C',
  brandred_10: '#470012',

  //家居棕 brown
  brown_1: '#F8F1EB',
  brown_2: '#F1E2D7',
  brown_3: '#E2C5AF',
  brown_4: '#D4A986',
  brown_5: '#C58C5E',
  brown_6: '#B76F36',
  brown_7: '#92592B',
  brown_8: '#6E4320',
  brown_9: '#4D2E17',
  brown_10: '#331F0F'
};

const colors_light_tmp = {
  // 主题色赛博紫专业紫
  theme_light_bg: getOpColor(colors_light_all.mauve_1, 0.5), ////大面积浅色背景//new
  theme_light: colors_light_all.mauve_1, //主题色最浅色标签底色//new
  theme_light2: colors_light_all.mauve_2, //用于灰色背景上/一级背景hover状态色
  theme_focus: colors_light_all.mauve_3, //主题色聚焦边框//new
  theme_hover: colors_light_all.mauve_5, //主题色hover//new//26-3-4修订
  theme_color: colors_light_all.mauve_6, //主题色、链接色//new//26-3-4修订
  theme_active: colors_light_all.mauve_7, //主题色点击//new//26-3-4修订

  // 信息色易用蓝//26-3-19修订
  info_light_bg: getOpColor(colors_light_all.blue_1, 0.5), //大面积浅色背景,错误色最浅，标签底色//new//26-3-4修订
  info_light: colors_light_all.blue_1, //信息色最浅，标签底色//new
  info_focus: colors_light_all.blue_3, //信息色聚焦、边框。。new
  info_hover: colors_light_all.blue_5, //信息色鼠标悬停//new
  info_color: colors_light_all.blue_6, //信息色//new
  info_active: colors_light_all.blue_7, //信息色active//new

  // 成功色
  success_light_bg: getOpColor(colors_light_all.kygreen_1, 0.5), //成功色最浅，标签底色//new
  success_light: colors_light_all.kygreen_1, //成功色最浅、标签背景
  success_focus: colors_light_all.kygreen_3, //成功色聚焦、边框
  success_hover: colors_light_all.kygreen_5, //成功色hover
  success_color: colors_light_all.kygreen_6, //成功色、信号好26-3-6修订
  success_active: colors_light_all.kygreen_7, //成功点击

  // 警告色
  warning_light_bg: colors_light_all.orange_1, //告警色最浅，标签底色
  warning_light: colors_light_all.orange_1, //告警色最浅，标签底色
  warning_focus: colors_light_all.orange_3, //告警色聚焦、边框
  warning_hover: colors_light_all.orange_5, //告警色鼠标悬停
  warning_color: colors_light_all.orange_6, //告警色、信号差26-3-6修订
  warning_active: colors_light_all.orange_7, //告警色点击

  // 错误色
  error_light_bg: getOpColor(colors_light_all.red_1, 0.6), //错误色最浅，标签底色//new
  error_light: colors_light_all.red_1, //错误色最浅，标签底色
  error_focus: colors_light_all.red_3, //错误色聚焦、边框
  error_hover: colors_light_all.red_5, //错误色鼠标悬停
  error_color: colors_light_all.red_6, //错误色
  error_active: colors_light_all.red_7, //错误色active

  // 信号一般-中等26-3-6修订
  average_light_bg: getOpColor(colors_light_all.yellow_1, 0.5), //常用于信号一般/vip氛围场景
  average_light: colors_light_all.yellow_1, //常用于信号一般/vip氛围场景
  average_light2: colors_light_all.yellow_2, //常用于信号一般/vip氛围场景
  average_focus: colors_light_all.yellow_3, //常用于信号一般/vip氛围场景
  average_hover: colors_light_all.yellow_5, //常用于信号一般/vip氛围场景
  average_color: colors_light_all.yellow_6, //常用于信号一般/vip氛围场景
  average_active: colors_light_all.yellow_7, //常用于信号一般/vip氛围场景

  //文字色26-3-11修订
  text_title: colors_light_all.gray_12, //标题文字色
  text_primary: colors_light_all.gray_11, //主要文字颜色
  text_secondary: colors_light_all.gray_9, //次要文字颜色
  text_secondary2: colors_light_all.gray_10, //次要文字颜色
  text_placeholder: colors_light_all.gray_7, //说明占位字符颜色、不可用
  text_white_title: colors_light_all.gray_1, //白色，标题&按钮
  text_white_secondary2: getOpColor(colors_light_all.gray_1, 0.65), //白色,正文或次要文字
  text_white_secondary: getOpColor(colors_light_all.gray_1, 0.45), //白色，辅助文案
  text_white_placeholder: getOpColor(colors_light_all.gray_1, 0.3), //白色对应禁用态
  text_black: colors_light_all.gray_12, //黑色

  //线条色
  border_base8: getOpColor(colors_light_all.blue_10, 0.08), //分割线，8%透明度
  border_darker16: getOpColor(colors_light_all.blue_10, 0.16), //边框，12%透明度
  border_darkerBtn: getOpColor(colors_light_all.blue_10, 0.24), //边框，24%透明度//NEW
  border_White12: getOpColor(colors_light_all.gray_1, 0.12), //白色分割，12%透明度
  border_White24: getOpColor(colors_light_all.gray_1, 0.24), //白色边框，24%透明度

  //图标色26-3-6修订
  icon_base: colors_light_all.mauve_6, //26-3-4修订
  icon_fill: getOpColor(colors_light_all.mauve_6, 0.08), //26-3-4修订
  icon_hover: colors_light_all.mauve_5, //26-3-4修订

  //背景色
  bg_page: colors_light_all.gray_2, //页面背景
  bg_popup: colors_light_all.gray_2, //灰底抽屉弹窗
  bg_dialog: colors_light_all.gray_1, //白底弹窗,对话框
  bg_popover: colors_light_all.gray_1, //气泡_浮层
  bg_toast: getOpColor(colors_light_all.gray_12, 0.9), //toast
  bg_toast_white: colors_light_all.gray_1, //toast白色
  bg_mask: getOpColor(colors_light_all.gray_13, 0.5), //蒙层
  bgg_MaskPreview: getOpColor(colors_light_all.gray_13, 0.95), //图片预览背景
  bg_page_White: colors_light_all.gray_1, //白色抽屉弹窗，存量备份
  bg_MaskLight: getOpColor(colors_light_all.gray_13, 0.25), //蒙层-更浅
  // 填充色
  fill1: colors_light_all.gray_1, //1级填充，深色透明//new
  fill1_onPage: colors_light_all.gray_1, //1级填充，深色不透明
  onFill_opacity4: getOpColor(colors_light_all.blue_10, 0.04), //2级填充_叠加层_hover//new
  onFill_Solid: colors_light_all.gray_2, ////2级填充，浅灰，不透明
  fill_3_opacity7: getOpColor(colors_light_all.blue_10, 0.07), //3级填充//new
  fill_4_opacity10: getOpColor(colors_light_all.blue_10, 0.1), //4级填充//new
  fill_5_opacity13: getOpColor(colors_light_all.blue_10, 0.13), //5级填充//new
  fill_picker: colors_light_all.gray_1, //分段选择器，选中态
  fill_banner: colors_light_all.mauve_6, //26-3-4新修改，设计写的代码

  //特殊透明背景-填充色26-3-6修订
  white_30: getOpColor(colors_light_all.gray_1, 0.3), //白-用于浅色背景-半透明卡片填充色
  white_50: getOpColor(colors_light_all.gray_1, 0.5), //白-用于浅色背景-半透明容器头部渐变色
  white_65: getOpColor(colors_light_all.gray_1, 0.95), //开发查询是否有使用到？未使用到请删除。26-3-11修订
  white_80: getOpColor(colors_light_all.gray_1, 0.8), //白-常用于深色背景-半透明容器头部渐变色
  gray_50: getOpColor(colors_light_all.gray_2, 0.5), //用于半透明页面背景
  gray_80: getOpColor(colors_light_all.gray_2, 0.8), //用于半透明页面背景
  //特殊透明背景-大背景26-3-6修订
  lime_light_bg: getOpColor(colors_light_all.lime_1, 0.5), //用于大面积浅色背景
  blue_light_bg: getOpColor(colors_light_all.blue_1, 0.5), //用于大面积浅色背景
  mauve_light_bg: getOpColor(colors_light_all.mauve_1, 0.5), //用于大面积浅色背景
  purple_light_bg: getOpColor(colors_light_all.purple_1, 0.5), //用于大面积浅色背景
  magenta_light_bg: getOpColor(colors_light_all.magenta_1, 0.5), //用于大面积浅色背景

  //特殊26-3-11修订
  brand_green: '#00DCA5', //睿易绿、VI绿色、亮绿色
  brand_red: colors_light_all.brandred_6, //锐捷红、锐捷logo使用
  text_vip: colors_light_all.orange_8, //会员金色、日暮橙色、文字VIP色
  fill_vip: '#EDD392', //会员金色、勋章金色、VIP色填充色背景色//26-3-19修订

  //阴影26-3-6修订
  shadow_1: getOpColor(colors_light_all.blue_10, 0.08), // 阴影-基础
  shadow_freeze: getOpColor(colors_light_all.blue_10, 0.08), //表格冻结阴影

  //10色图表26-3-6修订
  chart_color_01: colors_light_all.mauve_5, //品牌紫色
  chart_color_02: colors_light_all.blue_6, //品牌蓝色
  chart_color_03: colors_light_all.kygreen_6, //睿易绿色
  chart_color_O4: colors_light_all.orange_5, //日暮橙色
  chart_color_05: colors_light_all.purple_5, //紫罗兰色
  chart_color_06: colors_light_all.kyblue_4, //睿易蓝色
  chart_color_07: colors_light_all.yellow_4, //金盏花色
  chart_color_08: colors_light_all.lime_4, //柠檬绿色
  chart_color_09: colors_light_all.mauve_4, //品牌紫色
  chart_color_10: colors_light_all.gray_5, //中性色

  //L牌-工具页banner文字映射特殊-其他不用
  tool_text_color: colors_light_all.gray_1, //banner标题&按钮
  tooll_text_secondary_color: getOpColor(colors_light_all.gray_1, 0.45) //工具页banner辅助文字
};

// 导出颜色对象：先展开 colors_light_all（原始颜色），再展开 colors_light_tmp（语义化颜色）
export const colors_light = {
  ...colors_light_all,
  ...colors_light_tmp
};

// module.exports = { colors_light, getOpColor };
